module.exports = __webpack_public_path__ + "static/media/coin10.b0133e24.png";